﻿window.cBuilderEmailWidgetCode = function(option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetcode'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>Code</div>").appendTo($DivBt)
        $DivBt.attr("title", "Saisissez votre propre code HTML")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetcode'>")
        $("<!-- DEBUT CODE -->").appendTo(option.element)
        var $Td = $("<td valign='top' style='word-break:break-word;with:100%;' width='100%' class='bodywidget tdwidget widgetheightauto txtsaisie'></td>").appendTo(option.element)
        $Td.attr("jsoncssdatawidget", JSON.stringify({}))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)
        $("<!-- FIN CODE -->").appendTo(option.element)
    }

    this.nom = "Code HTML"
    this.icone = "fas fa-code"

    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()

        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Code HTML:</div>").appendTo(contentElement)
        var oldHtml = option.parent.mGetContenuWidget().html()

        var $TxtArea = $('<textarea style="width: 100%;"></textarea>').appendTo(contentElement);
        $TxtArea.val(oldHtml);
        var editorMirror = null
        window.setTimeout(function () {
            editorMirror = CodeMirror.fromTextArea($TxtArea[0], {
                mode: "text/html",
                autoCloseTags: true,
                styleActiveLine: true,
                lineNumbers: true,
                extraKeys: { "Ctrl-Space": "autocomplete" },
                highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
                theme: "dracula",
                matchBrackets: true,
                lineWrapping: true
            });
            editorMirror.on("change", function () {
                if (contentElement.closest("body").length == 0) return
                var html = editorMirror.getValue()
                if (oldHtml != html) {
                    oldHtml = html
                    option.parent.mGetContenuWidget().html(html)
                    Me.isDirty = true
                }
            });
        }, 0)
    }

    this.mRemoveStyle = function() {

    }

    this.mUpdateCss = function () {

    }

}